import React, { Component, useState } from 'react';
import Slider from "react-slick";

import SectionTitle from '../../components/SectionTitle'
import SingleEvent from '../../components/Event/SingleEvent';
import bgImage from '../../assets/images/hero/indian-642055_1920@2x.png'
import events from '../../data/Events.json';

const IndustryPartner = ({govtPartnerList}) => {
    const eventSettings = {
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                }
            },
            {

                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                }
            }
        ]
    };
    const govtPartners=[
        "./img/partners/govt-1.png",
        "./img/partners/govt-2.png",
        "./img/partners/govt-3.png",
        "./img/partners/govt-4.png",

        "./img/partners/govt-1.png",
        "./img/partners/govt-2.png",
        "./img/partners/govt-3.png",
        "./img/partners/govt-4.png",

        "./img/partners/govt-1.png",
        "./img/partners/govt-2.png",
        "./img/partners/govt-3.png",
        "./img/partners/govt-4.png",

        "./img/partners/govt-1.png",
        "./img/partners/govt-2.png",
        "./img/partners/govt-3.png",
        "./img/partners/govt-4.png", 

    ];

    return (
        <div className="react-upcoming__event blog__area py-5" style={{background:"none"}}>
            <div className="container">
                <SectionTitle Title="Our  " subtitle="Partners" />
                <h2 className='text-center mb-1 mt-4' style={{fontWeight:"600"}}>Government Partners</h2>
                <p className=' py-2 text-center' style={{ fontWeight: "600" }}>
                Ocfit collaborates with various government initiatives focused on skill development and vocational training. These partnerships enable us to effectively reach and financially empower our target populations, aligning our efforts with national goals for workforce development.
</p>
                <div className="event-slider owl-carousel wow animate__fadeInUp" data-wow-duration="0.3s">
                    <Slider {...eventSettings}>
                        {govtPartnerList?.map((item, index) => {
                            return (
                                <div key={index} className='col p-2'>
                                 <div className='rounded-3 d-flex justify-content-center align-items-center' style={{border:"1px solid black",height:"140px"}} >
                                  <img src={item?.logoUrl} width={102} height={102} className='' style={{width:"85%",height:"85%",objectFit:"contain"}}/>
                                 </div>
                                </div>
                            )
                        }).slice(0, 6)}
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default IndustryPartner;